import { tempMeeApi } from '~/services/api';
import type {
  ICreateUserApiEnvelope,
  ICreateUserApiPayload,
  ICreateUserApiResponse,
} from '../types/SignUp.api';

export const createUser = async (
  payload: ICreateUserApiPayload,
): Promise<ICreateUserApiResponse> => {
  const { data: envelope } = await tempMeeApi.post<ICreateUserApiEnvelope>(
    '/auth-service/users',
    payload,
  );
  return envelope.data;
};
